import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Header from './Header.jsx';
import Menu from './Menu.jsx';
import Content from './Content.jsx';

class Dashboard extends React.Component {

    constructor() {

        super();

        this.state = {
            toggle: true
        };

        this.setToggle = this.setToggle.bind(this);

        if (localStorage.usuarioInfo === null || localStorage.usuarioInfo === undefined) {
            window.location.href = "/";
        }

    }

    setToggle() {
        this.setState({ toggle: !this.state.toggle });
    }

    render() {
        return (
            <div id="dashboard-div">
                <Header />
                <Switch>
                    <Route path="/:id" children={<Content toggle={ this.state.toggle } />} />
                </Switch>
                <Menu toggle={ this.state.toggle } setToggle={ this.setToggle } />
            </div>
        );
    }

}

export default Dashboard;

